import { useState } from 'react';

import { Check } from '@mui/icons-material';
import { Grid, Typography } from '@mui/material';
import { Button, Confirm, useNotify, useRefresh, useUpdate } from 'react-admin';
import { DataProviderResource } from 'src/constants';
import { OfferDetailsDto } from 'src/dtos';

export const CompleteOfferButton = ({ record }: { record: OfferDetailsDto }) => {
  const [isOpen, setIsOpen] = useState(false);
  const notify = useNotify();
  const refresh = useRefresh();
  const [completeOffer] = useUpdate<OfferDetailsDto>();

  const onComplete = () => {
    completeOffer(
      DataProviderResource.CompleteOffer,
      {
        id: record.id,
        data: {},
      },
      {
        mutationMode: 'pessimistic',
        onSuccess: () => {
          notify(`Offer was successfully completed.`, {
            type: 'success',
            undoable: true,
          });
          onClose();
        },
        onSettled: () => {
          refresh();
        },
        onError: (error: any) => {
          notify(`${JSON.stringify(error?.message ?? error)}`, {
            type: 'error',
          });
        },
      },
    );
  };

  const onClose = () => {
    setIsOpen(false);
  };

  const onConfirm = () => {
    onComplete();
  };

  return (
    <>
      <Button
        label='Complete'
        onClick={() => {
          setIsOpen(true);
        }}
        startIcon={<Check />}
      />
      <Confirm
        isOpen={isOpen}
        title='Complete Offer'
        content={
          <Grid container>
            <Grid item xs={12}>
              <Typography variant='h6'>Are you sure you want to complete the offer?</Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography variant='body2'>
                *Offer completion will update approved offer orders status to completed.
              </Typography>
            </Grid>
          </Grid>
        }
        onConfirm={onConfirm}
        onClose={onClose}
      />
    </>
  );
};
